import { setStoreProductVariantsAction as setStoreProductVariantsOperation } from 'editor/src/store/mockup/slice';

export default setStoreProductVariantsOperation;
